export enum Environment {
    LOCAL = 'local',
    DEV = 'dev',
    STAGING = 'staging',
    PRODUCTION = 'production',
}

export function getEnvironment(): Environment {
    const currentLocation = window.location.hostname;
    if (currentLocation.includes('localhost')) {
        return Environment.LOCAL;
    }

    switch (currentLocation) {
        case 'dev-partnerportal.aws.containex.com':
        case 'portal.dev.containex.com':
            return Environment.DEV;
        case 'test-partnerportal.aws.containex.com':
        case 'portal.test.containex.com':
            return Environment.STAGING;
        default:
            return Environment.PRODUCTION;
    }
}

export function getSupplierPortalUrl(): string {
    switch (getEnvironment()) {
        case Environment.LOCAL:
            return 'http://localhost:5173/?spp';
        case Environment.DEV:
            return `https://supplier.dev.containex.com${import.meta.env.BASE_URL}`;
        case Environment.STAGING:
            return `https://supplier.test.containex.com${import.meta.env.BASE_URL}`;
        case Environment.PRODUCTION:
            return `https://supplier.containex.com${import.meta.env.BASE_URL}`;
    }
}

export function getPartnerPortalUrl(): string {
    switch (getEnvironment()) {
        case Environment.LOCAL:
            return 'http://localhost:5173/';
        case Environment.DEV:
            return `https://portal.dev.containex.com${import.meta.env.BASE_URL}`;
        case Environment.STAGING:
            return `https://portal.test.containex.com${import.meta.env.BASE_URL}`;
        case Environment.PRODUCTION:
            return `https://portal.containex.com${import.meta.env.BASE_URL}`;
    }
}
